(function () {
  "use strict";

  function initializeGallery(root) {
    if (root.dataset.apcReady === "true") return;

    var track = root.querySelector("[data-apc-track]");
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-apc-slide]"));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-apc-thumb]"));
    var previous = root.querySelector("[data-apc-prev]");
    var next = root.querySelector("[data-apc-next]");
    var current = root.querySelector("[data-apc-current]");

    if (!track || slides.length < 2 || !previous || !next) return;

    var activeIndex = 0;
    var updateQueued = false;
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function update(index) {
      activeIndex = Math.max(0, Math.min(slides.length - 1, index));
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === slides.length - 1;
      if (current) current.textContent = String(activeIndex + 1);

      thumbs.forEach(function (thumb, thumbIndex) {
        var isActive = thumbIndex === activeIndex;
        thumb.classList.toggle("is-active", isActive);
        if (isActive) thumb.setAttribute("aria-current", "true");
        else thumb.removeAttribute("aria-current");
      });
    }

    function goTo(index) {
      var target = slides[Math.max(0, Math.min(slides.length - 1, index))];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft, behavior: reduceMotion ? "auto" : "smooth" });
      update(index);
    }

    function updateFromScroll() {
      updateQueued = false;
      var nearestIndex = 0;
      var nearestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });
      update(nearestIndex);
    }

    previous.addEventListener("click", function () { goTo(activeIndex - 1); });
    next.addEventListener("click", function () { goTo(activeIndex + 1); });
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener("click", function () { goTo(index); });
    });
    track.addEventListener("scroll", function () {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(updateFromScroll);
    }, { passive: true });
    track.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft") { event.preventDefault(); goTo(activeIndex - 1); }
      if (event.key === "ArrowRight") { event.preventDefault(); goTo(activeIndex + 1); }
      if (event.key === "Home") { event.preventDefault(); goTo(0); }
      if (event.key === "End") { event.preventDefault(); goTo(slides.length - 1); }
    });

    root.dataset.apcReady = "true";
    root.classList.add("is-enhanced");
    update(0);
  }

  function initializeAll(scope) {
    var galleries = scope.querySelectorAll ? scope.querySelectorAll("[data-apc-gallery]") : [];
    Array.prototype.forEach.call(galleries, initializeGallery);
  }

  function start() {
    initializeAll(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches("[data-apc-gallery]")) initializeGallery(node);
          initializeAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
